var map = {
	"./clear-day.png": 61,
	"./clear-night.png": 62,
	"./cloudy.png": 63,
	"./fog.png": 64,
	"./partly-cloudy-day.png": 65,
	"./partly-cloudy-night.png": 66,
	"./rain.png": 67,
	"./sleet.png": 68,
	"./snow.png": 69,
	"./wind.png": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;